import { Flex, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { AiFillEye } from "react-icons/ai";

interface NumeroLeiturasProps {
  numDestinos?: number;
  numDestinosLidos?: number;
  onClick?: () => any;
}

function NumeroLeituras({
  numDestinos,
  numDestinosLidos,
  onClick,
}: NumeroLeiturasProps) {
  return (
    <Flex
      cursor={onClick ? "pointer" : "default"}
      onClick={onClick}
      gridGap={2}
      alignItems="center"
    >
      <Text fontSize={14} color={colors.black600}>
        lida por {numDestinosLidos || 0} / {numDestinos}{" "}
        {numDestinos === 1 ? "unidade" : "unidades"}
      </Text>
      {onClick ? <AiFillEye fontSize={18} color={colors.black700} /> : null}
    </Flex>
  );
}

export default NumeroLeituras;
